// Service-provided text (form title, labels, placeholders, ...) arrives as English
// plus an optional i18n key. Translate when a key is present; otherwise keep the
// service text, so older services (without keys) keep working unchanged.
export const tx = (t, key, fallback) =>
  key ? t(key, { defaultValue: fallback ?? key }) : fallback;

const translateField = (t, field) => {
  const translated = { ...field };

  if (field.labelKey) {
    translated.label = tx(t, field.labelKey, field.label);
  }
  if (field.placeholderKey) {
    translated.placeholder = tx(t, field.placeholderKey, field.placeholder);
  }
  if (field.displayValueKey) {
    translated.displayValue = tx(t, field.displayValueKey, field.displayValue);
  }

  return translated;
};

// Returns a copy of the ticket config with every keyed string translated. Field
// ids, types, values and validation are untouched, so form logic is unaffected;
// validation messages built from `field.label` automatically use the translated label.
export const translateTicketConfig = (config, t) => {
  if (!config) {
    return config;
  }

  return {
    ...config,
    formTitle: tx(t, config.formTitleKey, config.formTitle),
    formSubtitle: tx(t, config.formSubtitleKey, config.formSubtitle),
    submitLabel: tx(t, config.submitLabelKey, config.submitLabel),
    fields: (config.fields ?? []).map(field => translateField(t, field))
  };
};
